import React, { Component } from 'react'
import { base } from '../../base';
import SideMenu from '../admin/SideMenu';
import { Button } from 'reactstrap';
import '../../styles/css/AdminMain.css'

class ManageSessions extends Component {
    constructor(props) {
        super(props);

        this.state = {
          session: {},
        };
    }

    componentWillMount() {
      var url_split = window.location.pathname.split('/');
      var session_id = url_split.pop() || url_split.pop();  // handle potential trailing slash
      
      this.session = base.syncState("sessionList/" + session_id, {
        context: this,
        state: 'session',
      });
    }

    componentWillUnmount() {
      base.removeBinding(this.session);
    }

    toggleLoadingScreen(){
      var dupObject = this.state.session
      dupObject.votingOn = !dupObject.votingOn
      this.setState({
        session: dupObject,
      });
    }

    render() {
      var currentSession = this.state.session || {};
      if(!currentSession.id){
        currentSession = null
      }
      var currentSessionTitle = '';
      var currentSessionId = '';
      if(currentSession){
        currentSessionTitle = currentSession.sessionName;
        currentSessionId = currentSession.id
      }
      var loadingButtonText = "HIDE LOADING SCREEN";
      if(this.state.session.votingOn){
        loadingButtonText = "SHOW LOADING SCREEN"
      }
        return (
          <div className="admin-wrapper">
            <SideMenu/>
            <div className="admin-main-panel">
              <h1>{currentSessionTitle}</h1>

              <h2 className="lines-on-sides">Current Session id: {currentSessionId}</h2>
              <div className="current-session question-box">
                <Button className="btn btn-warning btn-admin btn-current-session" onClick={ () => this.toggleLoadingScreen()}>{loadingButtonText}</Button>
                <h4>{currentSessionTitle}</h4>
              </div>
            </div>
         </div>
        );
    }
}

export default ManageSessions;



// WEBPACK FOOTER //
// ./src/components/admin/ManageSessions.js